/**
 * WITHOUT-AXIS-COLOR.MODAL
 * Edit the color of the topics without axis
 */

import Modal from "@/components/modal"
import ColorPickerWidget from "@/widgets/color-picker.widget"
import { SESSION_COLORS } from "@/redux/_session.types"
import { store, useAppSelector } from "@/core/root-reducer"
import { templateEditAndUpdate } from "@/redux/template.actions"
import { t } from "i18next"

interface OwnProps {
  onClose: Function
}

type Props = OwnProps

function WithoutAxisColorModal(props: Props) {
  //Template holding the color in its options
  const template = useAppSelector((state) => state.template)

  //Save the color in the template options
  function selectColor(color: string) {
    store.dispatch(
      templateEditAndUpdate("options", {
        ...template.active.options,
        withoutAxisColor: color
      })
    )
  }

  return (
    <Modal
      disableOverflow
      status={template.status}
      title={t("without_axis_color_edit")}
      onClose={props.onClose}
      onNext={props.onClose}>
      <div className="flex">
        <ColorPickerWidget
          isCustom
          colors={SESSION_COLORS}
          title={t("color")}
          selectedColor={template.active.options.withoutAxisColor}
          onSelect={selectColor}
        />
      </div>
    </Modal>
  )
}

export default WithoutAxisColorModal
